import { Type } from '@/components/common'
import { useExperiment } from '@/experimentation'
import { Campaign } from '@/services/api/campaign'
import useSiteAssets from '@/services/hooks/useSiteAssets'

interface Props {
  campaign: Campaign
  className?: string
}

const TimeRemaining: React.FC<Props> = ({ campaign, className }) => {
  const { timeRemainingValue, timeRemainingDimension } = campaign.timeRemaining
  const clarificationSymbol = campaign.isSellingFast ? '†' : '*'
  const siteAssets = useSiteAssets()

  return (
    <Type
      as="p"
      variant="paragraph-lg"
      className={className}
      data-testid="TimeRemaining"
    >
      {timeRemainingDimension === 'Hour' && timeRemainingValue === 1
        ? 'Less Than '
        : ''}
      {timeRemainingValue} {timeRemainingDimension}{' '}
      {siteAssets?.timeRemainingDescriptor}
      {clarificationSymbol}
    </Type>
  )
}

// Note if the hidden variation wins, we can hide TimeRemaining using siteAssets.hideTimeRemaining
const TimeRemainingExperiment = (props: Props) => {
  const [hideTimeLeft] = useExperiment('angel-3-hide-time-left', false)
  if (hideTimeLeft) return null
  return <TimeRemaining {...props} />
}

const TimeRemainingWrapper = (props: Props) => {
  if (props.campaign.slug === 'angel-3') {
    return <TimeRemainingExperiment {...props} />
  }
  return <TimeRemaining {...props} />
}

export default TimeRemainingWrapper
